import UserServ from '@api/Users/UserServ';

/**
 * EL SELLO DE CREACIÓN que un documento lleva encima (D9 del
 * `PLAN-BITACORA-ACTIVITY-LOGS.md`). Se escribe una sola vez, al crear.
 *
 * Vive aparte de `ActivityOrigin` —que es quien lo LEE— porque necesita
 * `UserServ`, y con él toda la cadena de Firebase: meterlo allá volvió impuro un
 * módulo que no lo era y tumbó cuatro suites de pruebas.
 *
 * ⚠️ **`createdBy` guarda `{ uid, name }`, NUNCA el `UserType` completo**:
 * `inventory-orders` embebe el perfil entero del empleado —con su teléfono y su
 * dirección— dentro de cada pedido, y eso es peso y datos personales repetidos en
 * cada documento. El nombre se congela a propósito: la auditoría quiere saber
 * cómo se llamaba quien lo hizo **entonces**.
 */
export interface CreationStamp {
    createdAt: Date;
    createdBy: { uid: string; name: string };
}

/**
 * El sello para un documento NUEVO. **Nunca lanza**: si no se puede resolver el
 * usuario, devuelve `{}` y el documento se guarda sin sello — un producto no se
 * queda sin guardar porque falló la auditoría (misma regla que `addActivityLog`).
 *
 * No cuesta lecturas en la práctica: `UserServ.getUser` cachea por uid con TTL de
 * 10 minutos y deduplica vuelos.
 */
export const buildCreationStamp = async (): Promise<Partial<CreationStamp>> => {
    try {
        const user = await UserServ.getUser();
        return {
            createdAt: new Date(),
            createdBy: { uid: user.uid, name: user.profile?.name || '' }
        };
    } catch (error) {
        console.error('No se pudo sellar la creación', error);
        return {};
    }
};

